var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaintServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 254,
    viewBox: "0 0 238 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_449)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5256,
    y: 44.5508,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.928,
    y: 99.8779,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.928,
    y: 111.456,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.928,
    y: 123.035,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.928,
    y: 134.613,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.999 73.0236V74.0508C53.999 75.4125 53.999 76.9414 53.5571 79.2467L52.0282 79.0914C52.4402 77.0369 52.4582 75.508 52.4701 74.23H46.0678V73.0236H53.999ZM54.9546 80.3814V81.6236H45.0406V80.3814H48.5881V76.6428H50.1051V80.3814H54.9546ZM65.5613 80.4292V81.6475H55.6115V80.4292H59.7682V77.9686H61.2852V80.4292H65.5613ZM61.3329 73.4775C61.3329 75.0303 62.7305 76.6667 65.2149 77.0489L64.5699 78.315C62.6588 77.9686 61.2374 76.9474 60.5207 75.5917C59.804 76.9414 58.3946 77.9746 56.4954 78.315L55.8504 77.0489C58.311 76.6667 59.6965 75.0183 59.7085 73.4775V72.7011H61.3329V73.4775ZM72.3577 72.8086V74.0269H70.1958C70.2077 75.293 70.9662 76.5174 72.7041 77.025L71.9755 78.2194C70.7751 77.8551 69.9449 77.1265 69.4672 76.1889C68.9834 77.2878 68.0995 78.1597 66.7916 78.5897L66.0152 77.3833C67.8188 76.816 68.631 75.4065 68.6549 74.0269H66.4333V72.8086H72.3577ZM74.8064 72.08V74.6003H76.2755V75.8425H74.8064V78.53H73.2775V72.08H74.8064ZM71.2469 78.745C73.5044 78.7331 74.9139 79.5095 74.9139 80.8353C74.9139 82.1611 73.5044 82.9495 71.2469 82.9495C68.9416 82.9495 67.5202 82.1611 67.5202 80.8353C67.5202 79.5095 68.9416 78.7331 71.2469 78.745ZM71.2469 79.9275C69.8136 79.9275 69.0372 80.2261 69.0491 80.8353C69.0372 81.4564 69.8136 81.767 71.2469 81.767C72.6564 81.767 73.4089 81.4564 73.4089 80.8353C73.4089 80.2261 72.6564 79.9275 71.2469 79.9275Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    y: 24,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 79.3271,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 90.9053,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 102.484,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1523,
    y: 114.062,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2234 52.4728V53.5C80.2234 54.8617 80.2234 56.3906 79.7814 58.6959L78.2525 58.5406C78.6646 56.4862 78.6825 54.9573 78.6945 53.6792H72.2922V52.4728H80.2234ZM81.1789 59.8306V61.0729H71.265V59.8306H74.8125V56.092H76.3294V59.8306H81.1789ZM91.7857 59.8784V61.0967H81.8359V59.8784H85.9926V57.4178H87.5095V59.8784H91.7857ZM87.5573 52.9267C87.5573 54.4795 88.9548 56.1159 91.4393 56.4981L90.7943 57.7642C88.8831 57.4178 87.4617 56.3966 86.7451 55.0409C86.0284 56.3906 84.619 57.4238 82.7198 57.7642L82.0748 56.4981C84.5353 56.1159 85.9209 54.4675 85.9328 52.9267V52.1503H87.5573V52.9267ZM98.5821 52.2578V53.4761H96.4201C96.4321 54.7423 97.1906 55.9666 98.9285 56.4742L98.1999 57.6687C96.9995 57.3044 96.1693 56.5757 95.6915 55.6381C95.2078 56.737 94.3239 57.6089 93.016 58.0389L92.2396 56.8326C94.0432 56.2652 94.8554 54.8557 94.8793 53.4761H92.6576V52.2578H98.5821ZM101.031 51.5292V54.0495H102.5V55.2917H101.031V57.9792H99.5018V51.5292H101.031ZM97.4713 58.1942C99.7288 58.1823 101.138 58.9587 101.138 60.2845C101.138 61.6104 99.7288 62.3987 97.4713 62.3987C95.166 62.3987 93.7446 61.6104 93.7446 60.2845C93.7446 58.9587 95.166 58.1823 97.4713 58.1942ZM97.4713 59.3767C96.0379 59.3767 95.2615 59.6753 95.2735 60.2845C95.2615 60.9056 96.0379 61.2162 97.4713 61.2162C98.8807 61.2162 99.6332 60.9056 99.6332 60.2845C99.6332 59.6753 98.8807 59.3767 97.4713 59.3767Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_449)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.43,
    y: 78.4912,
    width: 94.1685,
    height: 124.864,
    rx: 3.76345,
    transform: "rotate(18.5895 146.43 78.4912)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 144.34,
    y: 136.162,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 144.34 136.162)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.649,
    y: 147.137,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 140.649 147.137)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.958,
    y: 158.111,
    width: 61.3916,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 136.958 158.111)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.267,
    y: 169.085,
    width: 44.1163,
    height: 3.11077,
    rx: 1.55538,
    transform: "rotate(18.5895 133.267 169.085)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.714 118.382L175.386 119.356C174.952 120.646 174.465 122.095 173.311 124.14L171.911 123.505C172.957 121.689 173.461 120.246 173.88 119.038L167.812 116.997L168.196 115.854L175.714 118.382ZM174.274 125.661L173.878 126.838L164.481 123.678L164.877 122.5L168.239 123.631L169.431 120.087L170.869 120.571L169.677 124.115L174.274 125.661ZM184.312 129.087L183.923 130.242L174.493 127.07L174.881 125.915L178.821 127.24L179.605 124.908L181.043 125.392L180.259 127.724L184.312 129.087ZM182.52 121.15C182.025 122.622 182.828 124.618 185.061 125.773L184.046 126.767C182.345 125.83 181.323 124.409 181.076 122.895C179.967 123.946 178.302 124.476 176.393 124.193L176.185 122.787C178.639 123.21 180.478 122.089 180.98 120.632L181.228 119.896L182.768 120.414L182.52 121.15ZM193.183 124.031L192.795 125.185L190.745 124.496C190.353 125.7 190.682 127.102 192.167 128.138L191.096 129.037C190.074 128.309 189.52 127.354 189.366 126.313C188.557 127.201 187.441 127.745 186.064 127.736L185.713 126.345C187.603 126.382 188.823 125.305 189.285 124.005L187.179 123.297L187.568 122.142L193.183 124.031ZM195.736 124.121L194.933 126.509L196.325 126.978L195.929 128.155L194.537 127.687L193.68 130.234L192.231 129.747L194.287 123.633L195.736 124.121ZM190.238 129.303C192.381 130.012 193.47 131.197 193.047 132.453C192.624 133.71 191.037 134.008 188.897 133.288C186.712 132.554 185.616 131.353 186.039 130.097C186.462 128.84 188.056 128.557 190.238 129.303ZM189.861 130.424C188.502 129.967 187.671 130.003 187.488 130.584C187.279 131.169 187.916 131.711 189.274 132.168C190.61 132.617 191.422 132.562 191.62 131.974C191.815 131.396 191.197 130.873 189.861 130.424Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.345,
    y: 212.224,
    width: 8.01823,
    height: 50.6459,
    transform: "rotate(-35 66.345 212.224)",
    fill: "#F85B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9635 203.264L72.9136 207.611L66.3295 212.222L64.9635 203.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.317 184.312L128.255 183.179L135.407 233.318L127.47 234.45L120.317 184.312Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.136 175.697L128.262 183.169L120.304 184.304L123.136 175.697Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_449",
    x: 13.5256,
    y: 44.5508,
    width: 101.695,
    height: 132.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_449",
    x: 39.75,
    y: 24,
    width: 101.695,
    height: 132.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_449",
    x: 107.627,
    y: 79.4932,
    width: 134.583,
    height: 153.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.76345,
    dy: 3.76345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_449"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_449",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 254,
    fill: "white",
    transform: "translate(0.5 0.00585938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaintServiceBody);
export default __webpack_public_path__ + "static/media/IcComplaintServiceBody.095958981f94f3af27d7df8ed1abf4d7.svg";
export { ForwardRef as ReactComponent };